export default "__VITE_ASSET__UlxKS5UG__"